module.exports = __webpack_public_path__ + "img/sponsorO07.e13a008d.png";